import DateDisplay from "./ConfigCharts/useFormattedDate"; // Import the date display component
import DateDisplayWithPicker from "./ConfigCharts/DateDisplayWithPicker";

export const tabsConfig = {
  tabs: [
    {
      label: "Estimated Settlements",
      charts: [
        { key: "RevenueChart", label: "Estimated Settlements", dateDisplay: <DateDisplay /> },
        { key: "GenerationChart", label: "Generation & Awards", dateDisplay: <DateDisplay /> },
      ],
      tables: [{ key: "RevenueTable", label: "Estimated Settlements Table" }],
    },
 {
  label: "Asset Revenue",
    displayLabel: "Estimated Settlement Summary",
  charts: [
    { 
      key: "RevenueWaterfall",
      label: "Revenue Summary",
      dateDisplay: <DateDisplayWithPicker />
    }
  ],
  tables: [
    { key: "RevenueSummaryTable", label: "Asset Revenue" }
  ],
},
    {
      label: "Volume",
      charts: [
        { key: "VolumeChart", label: "Volume", dateDisplay: <DateDisplay /> },
      ],
      tables: [{ key: "VolumeTable", label: "Volume" }],
    },
    {
      label: "Price",
      charts: [
        { key: "PriceChart", label: "Price $/MWh", dateDisplay: <DateDisplay /> },
      ],
      tables: [{ key: "PriceTable", label: "Price $/MWh" }],
    },


    // {
    //   label: "Outages",
    //   charts: [{ key: "OutagesChart", label: "Outages" },],
    //   tables: [{ key: "OutagesTable", label: "Outages" },],
    // }

  ],
};
